import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { UserPreSharedKeyResponse } from 'app/shared/models/user-presharedkey-response.model';
import { UserPreSharedKey } from 'app/shared/models/user-presharedkey.model';

@Component({
  selector: 'app-two-factor-setup',
  templateUrl: './two-factor-setup.component.html',
  styleUrls: ['./two-factor-setup.component.scss']
})
export class TwoFactorSetupComponent implements OnInit {

  currentObject: UserPreSharedKey;
  authenticationCode: string;

  private static readonly twoFactorRegistrationUrl: string = "otpauth://totp/{0}?secret={1}&issuer=AIS";
  protected preSharedKeySavedMessage: string;

  get qrcodeDataUrl(): string {
    return TwoFactorSetupComponent.twoFactorRegistrationUrl.replace("{0}", this.currentObject.Email).replace("{1}", this.currentObject.PreSharedKey);
  }

  //qrcodeData: string ="otpauth://totp/Example:alice@google.com?secret=JBSWY3DPEHPK3PXP&issuer=Example"
  //qrcodeData: string = "otpauth://totp/Artificial Intelligence System?secret=JBSWY3DPEHPK3PXP&issuer=AIS";

  constructor(private authenticationService: AuthenticationService, protected translateService: TranslateService) {
  }

  ngOnInit() {
    this.initializeObject();
    this.generateNewPreSharedKey();
    this.translateService.get(['account.twoFactorSetup.preSharedKeySavedMessage'])
      .subscribe(translations => {
        this.preSharedKeySavedMessage = translations['account.twoFactorSetup.preSharedKeySavedMessage'];
      });
  }

  initializeObject() {
    if (this.currentObject == null) {
      this.currentObject = new UserPreSharedKey();
    }

    this.authenticationCode = null;
  }

  generateNewPreSharedKey() {
    this.authenticationService.getGeneratedPreSharedKey((userPresharedKey) => {
      this.currentObject = userPresharedKey
    });
  }

  onSubmit(form: NgForm) {
    this.authenticationService.savePreSharedKey(new UserPreSharedKeyResponse(this.authenticationCode, this.currentObject.PreSharedKey), () => this.authenticationService.logout(), this.preSharedKeySavedMessage);
  }
}
